// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2uXAN","selected":"Chip_selected__3YAaP"};